export default __webpack_public_path__ + "static/media/wibsIcon.591572b9.png";